<div class="w-100 countdown-container px-2 py-3 d-flex justify-content-evenly">
  <div class="countdown-segment">
    {{ countdownTimer.days }}
    <span class="segment-label">{{ 'Days' | translate }}</span>
  </div>
  <div class="separator">:</div>
  <div class="countdown-segment">
    {{ countdownTimer.hours }}
    <span class="segment-label">{{ 'Hours' | translate }}</span>
  </div>
  <div class="separator">:</div>
  <div class="countdown-segment">
    {{ countdownTimer.minutes }}
    <span class="segment-label">{{ 'Minutes' | translate }}</span>
  </div>
  <div class="separator">:</div>
  <div class="countdown-segment">
    {{ countdownTimer.seconds }}
    <span class="segment-label">{{ 'Seconds' | translate }}</span>
  </div>
</div>
